import { client } from '../client';
import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

export const triggerMobileHandoff = async (userRole?: string): Promise<any> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const { data } = await client.post<any>(`${prefix}/mobile_handoff/create_mobile_handoff_notification`);

  return data;
};
